import React, { PropTypes, PureComponent } from 'react';

import ProductFamilyItem from './ProductFamilyItem';
import './ProductFamily.scss';

class ProductFamily extends PureComponent {
  render() {
    const productFamilyItems = this.props.productFamily.map((item, index) =>
      <ProductFamilyItem
        key={`productfamily_item_${index}`}
        label={`${item.label.replace('{h}', new Date().getHours())}`}
        productId={item.productId}
        isProductActive={item.productId === this.props.productId}
        urlParams={this.props.urlParams}
      />);

    return (
      <div className="mt-wrapper-bottom-panel-family">
        <div className="mt-wrapper-shadow-panel-family">
          {productFamilyItems}
        </div>
      </div>
    );
  }
}

ProductFamily.defaultProps = {
  productFamily: PropTypes.object,
  productId: PropTypes.string,
  urlParams: PropTypes.object,
};

ProductFamily.defaultProps = {
  productFamily: {},
  productId: '',
  urlParams: {},
};

export default ProductFamily;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/ProductFamily/index.js
 **/